// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"c75fd052","293":"66aea544","502":"fea9e60b","758":"c75fd052"}[chunkId] + ".chunk.css";
};